import { fork } from 'redux-saga/effects';

import { walletWatcher } from './wallet';
import { suppliesWatcher } from './supplies';
import { borrowsWatcher } from './borrows';
import { agreementsWatcher } from './agreements';
import { organizationWatcher } from './organization';
import { vaultsWatcher } from './vaults';
import { userVaultsWatcher } from './userVaults';

export default function* rootSaga() {
    yield fork(walletWatcher);
    yield fork(suppliesWatcher);
    yield fork(borrowsWatcher);
    yield fork(agreementsWatcher);
    yield fork(organizationWatcher);
    yield fork(vaultsWatcher);
    yield fork(userVaultsWatcher);
}
